var _circle, _circle2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribblesLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FDF2F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2861_58",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2861_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6363 109.19C100.136 108.392 103.62 110.583 104.418 114.083C107.198 126.281 115.167 131.573 124.256 137.041C124.578 137.235 124.905 137.431 125.237 137.63C129.325 140.079 134.061 142.916 137.603 146.598C141.831 150.994 144.484 156.653 143.999 164.217C143.519 171.688 139.565 177.251 134.363 181.127C129.324 184.881 122.947 187.22 116.686 188.718C104.13 191.724 90.0244 191.81 82.2011 191.329C78.618 191.109 75.8921 188.025 76.1126 184.442C76.3331 180.859 79.4165 178.133 82.9995 178.354C90.1435 178.793 102.833 178.667 113.66 176.075C119.091 174.776 123.552 172.97 126.595 170.703C129.474 168.557 130.843 166.221 131.025 163.385C131.254 159.822 130.193 157.647 128.233 155.61C125.938 153.223 122.622 151.229 117.944 148.415C117.815 148.337 117.685 148.259 117.554 148.18C108.285 142.603 95.8249 134.885 91.7429 116.972C90.9453 113.472 93.1362 109.988 96.6363 109.19Z",
    fill: "url(#paint0_linear_2861_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8706 194.18L34.5059 198.018C34.5059 198.018 17.5435 179.272 19.0181 156.143C20.9207 126.297 33.8784 62.7267 33.8784 62.7267L72.1648 60.0234C72.1648 60.0234 86.1896 106.514 95.1071 147.625C100.724 173.519 88.8706 194.18 88.8706 194.18Z",
    fill: "url(#paint1_linear_2861_58)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1691 68.9329L70.151 66.1805C70.151 66.1805 81.6573 77.8204 82.8121 94.1759C83.4549 103.281 81.0852 116.611 78.8577 126.641L72.3199 186.485C75.6696 192.492 75.1703 193.491 73.0577 196.934L63.0296 197.642C60.6058 194.573 59.6564 193.046 63.3477 186.234C63.2433 182.54 63.146 179.027 63.0529 175.665C62.7364 164.237 62.4683 154.557 62.1319 145.446C60.4513 145.87 58.7981 146.179 57.3012 146.284C55.8152 146.389 54.1406 146.318 52.4179 146.139L56.6708 186.743C61.0044 191.666 60.2004 193.933 58.9576 197.437C58.897 197.608 58.8354 197.782 58.7733 197.959L49.9254 198.584C49.705 198.402 49.4942 198.233 49.2936 198.071C46.7465 196.021 45.8403 195.291 47.8487 188.396C46.9651 184.808 46.1268 181.395 45.3246 178.129C40.9386 160.273 37.6315 146.809 33.8913 133.049C29.57 122.892 23.6011 107.467 22.9611 98.4018C22.2612 88.4894 31.1691 68.9329 31.1691 68.9329Z",
    fill: "url(#paint2_linear_2861_58)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3307 30.9231C89.091 29.5871 68.5922 39.9945 68.5922 39.9945C65.8073 38.5071 62.9457 37.2866 60.2453 36.6577C55.8779 35.6405 50.5781 35.8553 45.5405 36.5619C45.5405 36.5619 29.6703 21.7335 27.4989 22.8639C25.3274 23.9942 27.6942 42.5071 27.6942 42.5071L25.8291 64.3858C27.3885 76.1319 50.034 87.739 50.034 87.739C50.034 87.739 74.2813 85.4984 79.7539 75.6156L84.7416 53.86C84.7416 53.86 93.5704 32.2591 91.3307 30.9231Z",
    fill: "url(#paint3_linear_2861_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1445 63.3114C48.339 66.066 45.9115 63.4691 43.1569 63.6636C40.4024 63.8581 38.3639 66.7703 38.1694 64.0157C37.9749 61.2612 40.1559 60.3667 42.9104 60.1723C45.665 59.9778 47.95 60.5568 48.1445 63.3114Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0525 69.043C67.9643 71.581 66.9951 68.1608 64.4571 67.0726C61.9191 65.9844 58.7735 67.6402 59.8617 65.1023C60.9499 62.5643 63.2984 62.7677 65.8364 63.8559C68.3743 64.9441 70.1407 66.505 69.0525 69.043Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2181 75.9527C52.5588 76.503 53.3246 76.5896 53.7796 76.1292L57.2075 72.6607C57.7944 72.0668 57.4382 71.0578 56.6086 70.9641L50.6134 70.2864C49.7838 70.1926 49.2114 71.0966 49.6509 71.8065L52.2181 75.9527Z",
    fill: "#C5AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8964 44.6824C64.2633 45.52 62.9321 44.9407 63.1136 43.9066L64.0255 38.7115C64.1439 38.0365 64.8908 37.678 65.4915 38.0077L67.6222 39.1769C68.1569 39.4704 68.3067 40.17 67.9389 40.6565L64.8964 44.6824Z",
    fill: "#62626C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.729 41.9334C49.6506 42.9804 48.2178 43.2145 47.8103 42.2469L45.7628 37.386C45.4968 36.7544 45.9304 36.0485 46.6139 36.0003L49.0384 35.829C49.6467 35.7861 50.1516 36.2931 50.106 36.9013L49.729 41.9334Z",
    fill: "#62626C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8861 54.8781C54.0218 55.9065 55.4404 56.0737 55.8114 55.105L62.1859 38.463C62.3764 37.9658 62.1436 37.4083 61.6487 37.2119C60.6083 36.7991 58.8341 36.1544 57.3973 35.9328C55.9408 35.7082 53.7383 35.7501 52.44 35.8024C51.8631 35.8256 51.4409 36.341 51.5164 36.9134L53.8861 54.8781Z",
    fill: "#62626C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2861_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6714 62.8926C66.5077 61.3897 65.9027 60.4317 65.1489 59.8912C64.3927 59.349 63.4882 59.2279 62.733 59.3967C60.2025 59.962 59.1881 62.2331 59.1702 64.7237C59.1522 67.2142 60.1346 69.9313 61.5956 71.3927C63.5754 71.975 66.4345 71.5535 68.618 70.3604C70.8016 69.1673 72.3191 67.2027 71.6165 64.7032C71.407 63.9582 70.8717 63.2192 70.0358 62.8104C69.2025 62.4029 68.0723 62.3243 66.6714 62.8926Z",
    fill: "#EE4848"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2861_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6511 59.3695C41.4792 58.4542 40.3888 58.2237 39.4907 58.3845C38.5898 58.5458 37.8841 59.1005 37.4851 59.7487C36.1482 61.9206 37.0538 64.1934 38.7975 65.9142C40.5412 67.6349 43.1306 68.8058 45.163 68.778C46.9314 67.7814 48.5951 65.4765 49.2514 63.1188C49.9078 60.7609 49.5634 58.3436 47.3192 57.1247C46.6503 56.7614 45.7621 56.632 44.9006 56.941C44.0418 57.249 43.2112 57.992 42.6511 59.3695Z",
    fill: "#EE4848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2861_58",
    x: 58.1699,
    y: 58.3259,
    width: 14.6201,
    height: 14.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2861_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2861_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2861_58",
    x: 35.8438,
    y: 55.7675,
    width: 14.7043,
    height: 14.011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2861_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2861_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2861_58",
    x1: 95.6675,
    y1: 109.411,
    x2: 78.1996,
    y2: 183.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2861_58",
    x1: 54.4632,
    y1: 110.207,
    x2: 60.3262,
    y2: 196.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2861_58",
    x1: 50.8569,
    y1: 67.5428,
    x2: 60.0588,
    y2: 197.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#91919B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2861_58",
    x1: 55.5943,
    y1: 33.938,
    x2: 51.0243,
    y2: 89.8988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93939D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80808C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribblesLove);
export default __webpack_public_path__ + "static/media/scribbles-love.9960f0e49f620ef2821aa1733009e8bc.svg";
export { ForwardRef as ReactComponent };